import { defineFetch } from 'resift';

const makeDeletePermissionFromRole = defineFetch({
  displayName: 'Delete Permission From Role',
  make: (roleId: string) => ({
    request: (permissionId: string) => ({ http }) =>
      http({
        method: 'DELETE',
        route: `/roles/${roleId}/permissions/${permissionId}`,
      }),
  }),
});

export default makeDeletePermissionFromRole;
